import WidgetType from "../enum/WidgetType";
import { WidgetDefinition } from "./common";

import Circle from './Circle'
import Image from './Image'
import Logo from './Logo'
import Product from './Product'
import ProductList from './ProductList'
import Promotion from './Promotion'
import Rectangle from './Rectangle'
import Text from './Text'
import Ticker from './Ticker'
import Video from './Video'

export default { Circle, Image, Logo, Product, ProductList, Promotion, Rectangle, Text, Ticker, Video }

export const allWidgetDefinitions: WidgetDefinition[] = [Circle, Image, Logo, Product, ProductList, Promotion, Rectangle, Text, Ticker, Video];

export function getWidgetDefinition(type: WidgetType): WidgetDefinition {

    // @ts-ignore
    return allWidgetDefinitions.find(def => def.type == type);
}